export default "__VITE_PUBLIC_ASSET__8f6d83f0__"